// Shared project data for Projects and ProjectDetails pages

export type Module = {
  id: number;
  moduleCode: string;
  moduleName: string;
  description: string;
  category: string;
  date?: string;
  YearSem: string;
  topics: string[];
  link?: string;
};

const modulesData = [
  {
    id: 1,
    moduleCode: 'CS1010',
    moduleName: 'Programming Methodology',
    description: 'An introductory courses for computer engineering students. One of my first programming course and it was taught in C language. It was also one of the few hardest courses I have taken in NUS. Totally an eye opening experience to programming because the professor introduced many technologies like Linux and Shell.',
    category: 'Programming',
    date: 'August 2022',
    YearSem: 'Y1S1',
    topics: [
      'C Programming',
      'Data Structures',
      'Algorithms',
      'Software Development',
      'Debugging Techniques',
      'Sorting Algorithms',
      'Memory Management',
      'Linux Command Line',
      'Shell Scripting',
      'Bash Scripting',
      'Vim Editor',
    ],
    link: 'https://nusmods.com/courses/CS1010/programming-methodology'
  },
  {
    id: 2,
    moduleCode: 'CG1111A',
    moduleName: 'Engineering Principles and Practices',
    description: '',
    category: 'Electronics',
    date: 'August 2022',
    YearSem: 'Y1S1',
    topics: [
      'Circuit Design',
      'Electronics Fundamentals',
      'Soldering Techniques',
      'Microcontroller Programming',
      'Embedded Systems',
      'Arduino Projects',
      'Basic Robotics',
      'Sensor Integration',
      'Signal Processing',
      'C programming',
      'Hardware Prototyping',
    ],
    link: 'https://nusmods.com/courses/CG1111A/engineering-principles-and-practice-i'
  },
  {
    id: 3,
    moduleCode: 'CS1231',
    moduleName: 'Discrete Structures',
    description: 'A module that introduces the fundamental concepts of discrete mathematics, including logic, set theory, combinatorics, and graph theory. It is essential for understanding algorithms and data structures in computer science.',
    category: 'Mathematics',
    date: 'January 2023',
    YearSem: 'Y1S2',
    topics: [
      'Logic and Proofs',
      'Set Theory',
      'Combinatorics',
      'Graph Theory',
      'Relations and Functions',
      'Recursion',
      'Counting Principles',
      'Algorithms',
      'Mathematical Induction',
      'Boolean Algebra',
    ],
    link: 'https://nusmods.com/courses/CS1231/discrete-structures'
  },
  {
    id: 4,
    moduleCode: 'CS2040C',
    moduleName: 'Data Structures and Algorithms',
    description: 'A core module that covers essential data structures and algorithms, including arrays, linked lists, trees, graphs, and sorting algorithms. It is crucial for building efficient software and understanding computational complexity.',
    category: 'Programming',
    date: 'August 2023',
    YearSem: 'Y2S1',
    topics: [
      'C++ Programming',
      'OOP Concepts',
      'Data Structures',
      'Algorithms',
      'Complexity Analysis',
      'Sorting Algorithms',
      'Searching Algorithms (Dijkstastra, BFS, DFS)',
      'Graph Algorithms',
      'Tree Structures',
      'Hashing Techniques',
      'Dynamic Programming',
      'Recursion',
      'Big O Notation',
    ],
    link: 'https://nusmods.com/courses/CS2040C/data-structures-and-algorithms'
  },
  {
    id: 5,
    moduleCode: 'MA1508E',
    moduleName: 'Linear Algebra',
    description: 'A foundational mathematics module that covers vector spaces, matrices, determinants, eigenvalues, and eigenvectors. It is essential for understanding many concepts in computer science and engineering.',
    category: 'Mathematics',  
    date: 'August 2023',
    YearSem: 'Y1S2',
    topics: [
      'Vector Spaces',
      'Matrices and Determinants',
      'Eigenvalues and Eigenvectors',
      'Linear Transformations',
      'Systems of Linear Equations',
      'Matrix Operations',
      'Orthogonality',
      'Inner Product Spaces',
      'Applications of Linear Algebra',
      'Matrix Factorization',
    ],
    link: 'https://nusmods.com/courses/MA1508E/linear-algebra-for-engineering'
  },
  {
    id: 6,
    moduleCode: 'CG2111A',
    moduleName: 'Engineering Principles and Practices II',
    description: 'A continuation of CG1111A, focusing on advanced engineering principles and practices, including project management, teamwork, and communication skills.',
    category: 'Electronics',
    date: 'January 2024',
    YearSem: 'Y1S2',  
    topics: [
      'C++ Programming',
      'Raspberry Pi Projects',
      'Networking Fundamentals',
      'Project Management',
      'Teamwork and Collaboration',
      'Communication Skills',
      'Advanced Circuit Design',
      'Embedded Systems Development',
      'Robotics Projects',
      'Sensor Integration',
      'Signal Processing',
      'Lidar and Camera Integration',
      'Hardware Prototyping',
      'Arduino Projects',
      'Microcontroller Programming',
    ],
    link: 'https://nusmods.com/courses/CG2111A/engineering-principles-and-practice-ii'
  },
  {
    id: 7,
    moduleCode: 'EE2026',
    moduleName: 'Digital Design',
    description: 'A module that covers the principles of digital design, including logic gates, combinational and sequential circuits, and digital system design using hardware description languages (HDLs).',
    category: 'Electronics',
    date: 'January 2024',
    YearSem: 'Y2S1',
    topics: [
      'Logic Gates',
      'Combinational Circuits',
      'Sequential Circuits',
      'Digital System Design',
      'Hardware Description Languages (HDLs)',
      'Verilog Programming',
      'FPGA Design',
      'Timing Analysis',
      'State Machines',
    ],
    link: 'https://nusmods.com/courses/EE2026/digital-design'
  },
  {
    id: 8,
    moduleCode: 'CG2027',
    moduleName: 'Transistor-level Digital Circuits',
    description: 'A module that focuses on the design and analysis of digital circuits at the transistor level, including MOSFETs, CMOS technology, and circuit simulation.',
    category: 'Electronics',
    date: 'January 2024',
    YearSem: 'Y2S1',
    topics: [
      'MOSFETs',
      'CMOS Technology',
    ],
    link: 'https://nusmods.com/courses/CG2027/transistor-level-digital-circuits'
  },
  {
    id: 9,
    moduleCode: 'CS2028',
    moduleName: 'Computer Organisation',
    description: 'A module that covers the fundamentals of computer organization, including instruction set architecture, memory hierarchy, and input/output systems.',
    category: 'Programming',
    date: 'January 2024',
    YearSem: 'Y2S2',
    topics: [
      'Instruction Set Architecture',
      'Memory Hierarchy',
      'Input/Output Systems',
      'Assembly Language Programming',
      'Computer Architecture',
      'CPU Design',
      'Cache Memory',
      'Virtual Memory',
      'Bus Systems',
      'Interrupts and Exceptions',
    ],
    link: 'https://nusmods.com/courses/CS2028/computer-organisation'
  },
  {
    id: 10,
    moduleCode: 'CS2113T',
    moduleName: 'Software Engineering',
    description: 'A module that introduces software engineering principles, including software development methodologies, project management, and software design patterns.',
    category: 'Programming',
    date: 'January 2024',
    YearSem: 'Y2S2',
    topics: [
      'Java Programming',
      'Software Development Life Cycle',
      'CLI Applications',
      'Object-Oriented Programming',
      'Software Development Methodologies',
      'Project Management',
      'Software Design Patterns', 
      'Agile Development',
      'Version Control Systems',
      'Testing and Debugging',  
      'Requirements Analysis',
      'Software Architecture',
      'User Interface Design',
      'Software Maintenance',
    ],
    link: 'https://nusmods.com/courses/CS2113T/software-engineering'
  },
  {
    id: 11,
    moduleCode: 'CG3207',
    moduleName: 'Computer Architecture',
    description: 'A module that delves into the design and organization of computer systems, including instruction set architecture, pipelining, and memory hierarchy.',
    category: 'Programming',
    date: 'August 2024',
    YearSem: 'Y3S1',
    topics: [
      'Instruction Set Architecture',
      'Pipelining',
      'Memory Hierarchy',
      'Cache Design',
      'Virtual Memory',
      'Input/Output Systems', 
      'Bus Systems',
      'Computer Organization',
      'Parallel Processing',
      'Performance Optimization',
      'CPU implementation project',
      'FPGA Design',
      'Assembly Language Programming',
    ],
    link: 'https://nusmods.com/courses/CG3207/computer-architecture'
  },
  {
    id: 12,
    moduleCode: 'Advanced Machine Learning',
    moduleName: 'Advanced Machine Learning',
    description: 'A module that explores advanced topics in machine learning, including deep learning, reinforcement learning, and natural language processing.',
    category: 'Machine Learning',
    date: 'August 2024',
    YearSem: 'Y3S2',
    topics: [
      'Deep Learning',
      'Reinforcement Learning',
      'Natural Language Processing',
      'Neural Networks',
      'Convolutional Neural Networks (CNNs)',
      'Recurrent Neural Networks (RNNs)',
      'Generative Adversarial Networks (GANs)',
      'VAEs (Variational Autoencoders)',
      'Bayesian Methods',
      'Latent Variable Models',
      'Markov Chain Monte Carlo (MCMC)',
      'Graphical Models',
    ],
  },
  {
    id: 13,
    moduleCode: 'Computer Vision',
    moduleName: 'Computer Vision',
    description: 'A module that covers the principles and techniques of computer vision, including image processing, feature extraction, and object recognition.',
    category: 'Machine Learning',
    date: 'March 2025',
    YearSem: 'Y3S2',
    topics: [
      'Image Processing',
      'Feature Extraction',
      'Object Recognition',
      'Convolutional Neural Networks (CNNs)',
      'Image Segmentation',
      'Optical Flow',
      '3D Reconstruction',
      'Image Classification',
      'Object Detection',
      'Image Generation',
      'Video Analysis',
      'Augmented Reality',
      'Virtual Reality',
      'Generative Models',
      'Neural Networks',
      'Deep Learning',
      'Reinforcement Learning',
      'Natural Language Processing',
      'Neural Networks',
      'Recurrent Neural Networks (RNNs)',
      'Generative Adversarial Networks (GANs)',
      'Variational Autoencoders (VAEs)',
      'Bayesian Methods',
      'Latent Variable Models',
    ],
  },
  {
    id: 14,
    moduleCode: 'Advanced Internet Technologies',
    moduleName: 'Advanced Internet Technologies',
    description: 'A module that explores advanced topics in internet technologies, including web development, cloud computing, and network protocols.',
    category: 'Internet Architecture',
    date: 'March 2025',
    YearSem: 'Y3S2',
    topics: [
      'Cloud Computing',
      'Network Protocols',
      'HTTP/HTTPS',
      'RESTful APIs',
      'GraphQL',
      'WebSockets',
      'Microservices Architecture',
      'Serverless Computing',
      'Content Delivery Networks (CDNs)',
      'Internet of Things (IoT)',
      'Network Security',
      'Blockchain Technology',
      'Distributed Systems',
      'Edge Computing',
      'Fog Computing',
      'Network Virtualization',
      'Software-Defined Networking (SDN)',
      'Network Function Virtualization (NFV)',
      'Network Performance Optimization',
      'Network Protocols',
      'Network Security',
      'Network Design',
      'Network Architecture',
      'Network Topologies',
    ],
  },
  {
    id: 15,
    moduleCode: 'Database Systems',
    moduleName: 'Database Systems',
    description: 'A module that covers the principles of database systems, including relational databases, SQL, and database design.',
    category: 'Database',
    date: 'March 2025',
    YearSem: 'Y3S2',
    topics: [
      'Relational Databases',
      'SQL (Structured Query Language)',
      'Database Design',
      'Normalization',
      'Entity-Relationship Modeling',
      'Database Management Systems (DBMS)',
      'Transactions and Concurrency Control',
      'Indexing and Query Optimization',
      'NoSQL Databases',
      'Distributed Databases',
      'View and Authorization',
      'Online Analytical Processing (OLAP)',
      'Relational Algebra',
      'XML Databases',
      'XPath and XQuery',
      'Json Databases',
    ],
  },
  {
    id: 16,
    moduleCode: 'EE4032',
    moduleName: 'Blockchain Engineering',
    description: 'A module that explores the principles and applications of blockchain technology, including smart contracts, consensus algorithms, and decentralized applications (dApps).',
    category: 'Blockchain',
    date: 'August 2023',
    YearSem: 'Y2S1',
    topics: [
      'Blockchain Fundamentals',
      'Smart Contracts',
      'Consensus Algorithms',
      'Decentralized Applications (dApps)',
      'Cryptographic Hash Functions',
      'Public and Private Blockchains',
      'Blockchain Security',
      'Distributed Ledger Technology (DLT)',
      'Ethereum and Solidity',
      'Hyperledger Fabric',
      'Blockchain Scalability',
    ],
    link: 'https://nusmods.com/courses/EE4032/blockchain-engineering'
  },


];

export default modulesData; 